<script>
  import { onMount } from "svelte";
  import OrderView from "./components/OrderView.svelte";
  import getOrders from "./utils/getOrders.js";

  export let customer = "";

  let customerOrders;
  let showOrderForm = false;
  let orderID = 0;
  let brk = 0;
  let lun = 0;
  let days = 0;
  let totalMeals = 0;
  let carb = "";
  let status = "";

  onMount(() => {
    customerOrders = getOrders(customer);
  });

  const seletedOrder = order => {
    const info = order.OrderInfo;
    orderID = info.OrderID;
    status = info.OrderStatus;
    brk = info.NumBrk;
    lun = info.NumLD;
    days = info.NumDays;
    carb = info.NoCarbs;
    totalMeals = brk + lun * days;
    showOrderForm = true;
    console.log(info);
  };
</script>

<main>
  <h1>Customer Number: {customer}</h1>
  {#await customerOrders}
    <p>Loading</p>
  {:then orders}
    {#if orders}
      <table>
        <thead>
          <tr>
            <td>Order Number</td>
            <td>Order Status</td>
            <td>Order Actions</td>
          </tr>
        </thead>
        <tbody>

          {#each orders as order, i (order.OrderInfo)}
            <tr>
              <td>{order.OrderInfo.OrderID}</td>
              <td>{order.OrderInfo.OrderStatus}</td>
              <td>
                <!-- {#if order.OrderInfo.OrderStatus === 'Completed'}
                  Order Is Complete
                {:else} -->
                <button on:click={() => seletedOrder(order)}>
                  Update Order
                </button>
                <!-- {/if} -->
              </td>
            </tr>
          {/each}
        </tbody>
      </table>
    {/if}

  {:catch error}
    <p>Error something went wrong</p>
  {/await}
  {#if showOrderForm}
    <OrderView id={orderID} {brk} {lun} {days} {carb} {totalMeals} />
  {/if}
</main>
